<ng-template #modal let-modal>
  <div class="offcanvas-header border-bottom">
    <h4 class="modal-title pull-left">{{ "label-title.wallet-history" | translate }}</h4>
    <button type="button" class="btn-close" (click)="closeModal()" id="close-filter-data-modal"></button>

  </div>
  <div class="offcanvas-body" id="scrollContainerElement">
    <h4 class="d-flex align-items-center pb-3">
      <span>{{ "label-title.current" | translate }} {{ "label-title.balance" | translate }} :</span>

      <span class="d-flex ms-1 currency-gap justify-content-center align-items-center">
        <span id="total-amount">
          {{ totalWalletAmount.toFixed(helper.adminSettings?.decimalPointValue) }}
        </span>
        <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
          {{ helper.adminSettings?.currencySign }}
        </span>
      </span>
    </h4>

    @for (item of creditHistory; track $index) {
    <div class="d-flex justify-content-between align-items-md-center border-bottom py-3">
      <p class="font-weight-medium mb-0 w-50">
        <span>{{ item.descriptionTitle }}</span>
        <br />
        <span class="text-muted small">{{ "label-title.balance" | translate }} :
          {{ item.totalWalletAmount?.toFixed(helper.adminSettings?.decimalPointValue) }}
        </span>
      </p>

      <div class="font-weight-bold mb-0 text-end">
        <div>
          <span [ngClass]="item.status === CreditStatus.ADDED ? 'text-success' : 'text-danger'"> {{ item.amount }} {{
            item.currencyCode }} </span><br />
        </div>
        <div>
          <span class="font-weight-normal">{{ item.createdAt | date : helper.DATE_FORMAT.DD_MM_YYYY }}</span>
        </div>
      </div>
    </div>
    } @empty {
    <div class="d-flex justify-content-center align-items-center" style="height: calc(100vh - 270px)">
      {{ "label-title.no-record-found" | translate }}
    </div>
    }
    <div class="text-center mt-3">
      <a href="javascript:void(0);" class="text-success">
        @if(isCreditHistoryLoading) {
        <i class="mdi mdi-loading mdi-spin fs-20 align-middle me-2"></i>
        } @if(page <= pageCount && creditHistory?.length !=0) { {{ "label-title.load-more" | translate | titlecase }} }
          </a>
    </div>
  </div>
</ng-template>